import PropTypes from "prop-types";

import {
  BUTTON_TYPE_VALUES,
  BUTTON_SHAPE_VALUES,
  BUTTON_SIZE_VALUES,
} from "@/constants/Button";

// Couple with AntD Button Api
export const ButtonsAttributes = {
  rootClassName: PropTypes.string,
  block: PropTypes.bool,
  classNames: PropTypes.object, // Semantic DOM style
  danger: PropTypes.bool,
  disabled: PropTypes.bool,
  ghost: PropTypes.bool,
  href: PropTypes.string,
  htmlType: PropTypes.string,
  icon: PropTypes.node,
  loading: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.shape({ delay: PropTypes.number }),
  ]),
  shape: PropTypes.oneOf(BUTTON_SHAPE_VALUES),
  size: PropTypes.oneOf(BUTTON_SIZE_VALUES),
  styles: PropTypes.object, // Semantic DOM style
  target: PropTypes.string,
  type: PropTypes.oneOf(BUTTON_TYPE_VALUES),
  onClick: PropTypes.func,
};

export const ButtonsPropTypes = PropTypes.shape(ButtonsAttributes);
